import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function QueEsSection() {
  const [ref, isInView] = useInView({
    threshold: 0.2
  });
  return <section id="que-es" className="py-16 sm:py-32 relative overflow-hidden bg-[#0c0c0e] border-t border-white/5 scroll-mt-[56px] sm:scroll-mt-[70px]" data-id="element-555">
      <div className="absolute top-0 right-0 w-full max-w-2xl h-full bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.05),transparent_50%)] pointer-events-none" data-id="element-556" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-557">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="flex flex-col gap-12 max-w-3xl mx-auto text-center" data-id="element-558">
          <div data-id="element-559">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-560">
              Qué es <span className="text-gold" data-id="element-561">realmente</span> el Código 888
            </h2>

            <div className="space-y-6 text-lg sm:text-xl text-white/80 font-medium leading-relaxed" data-id="element-562">
              <p className="text-white font-bold" data-id="element-563">
                El Código 888 no es un libro.
              </p>
              <p data-id="element-564">
                Es un sistema diseñado para ayudarte a observar tu forma de
                pensar, decidir y percibir oportunidades.
              </p>
              <p data-id="element-565">
                No trabaja desde la presión externa. Trabaja desde tu mundo
                interno.
              </p>
              <p data-id="element-566">
                Te guía a reconocer patrones, ordenar tu mente y operar desde
                una nueva configuración de claridad, enfoque y dirección.
              </p>
            </div>
          </div>

          <div className="relative aspect-video rounded-2xl overflow-hidden" data-id="element-567">
            <div className="absolute inset-0 bg-gold/20 blur-[100px] rounded-full" data-id="element-568" />
            <video src="https://cdn.shopify.com/videos/c/o/v/907e877aadc5408da793d66cb072d484.mp4" autoPlay muted loop playsInline preload="metadata" aria-label="El Código 888 Sistema" className="relative z-10 w-full h-full object-cover drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-569" />
          </div>
        </motion.div>
      </div>
    </section>;
}